import {
  AssignHostFamilyRequestInput,
  ChangeHostFamilyRequestInput,
  UnassignHostFamilyRequestInput
} from '../../lib/types/models/center/assign-host-family'
import { Center } from '../../lib/types/models/center/center'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const assignHostFamilyToEnrollment = (input: AssignHostFamilyRequestInput) => {
  const { centerId, id, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.centers.assignHostFamilyToEnrollment.url, {
        id: centerId,
        enrollmentId: id
      })
    )
    .post<Center>(rest)
}

export const unassignEnrollmentHostFamily = (input: UnassignHostFamilyRequestInput) => {
  const { centerId, id, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.centers.unassignHostFamilyToEnrollment.url, {
        id: centerId,
        enrollmentId: id
      })
    )
    .post(rest)
}

export const changeEnrollmentHostFamily = (input: ChangeHostFamilyRequestInput) => {
  const { centerId, id, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.centers.changeEnrollmentHostFamily.url, {
        id: centerId,
        enrollmentId: id
      })
    )
    .post<Center>({ ...rest })
}
